/* Site-Specific JavaScript */
jq(document).ready(function(){
    let bannerSlider = jq('.page-banner-slides');
    if (bannerSlider.length) {
        bannerSlider.slick({
            infinite: true,
            dots: true,
            arrows: true,
            prevArrow: '<div class="prev-arrow"><span class="sr-only">Prev</span></div>',
            nextArrow: '<div class="next-arrow"><span class="sr-only">Next</span></div>',
            slidesToShow: 1,
            slidesToScroll: 1
        });    
    }
    jq('.page-banner-controls').append(jq('.prev-arrow')).append(jq('.slick-dots')).append(jq('.next-arrow'));
});